import t from 'prop-types'
import React from 'react'

import { sortByOrder } from '../common/Utilities';

function makeLookup(arr, prop) {
  let lkup = {}
  for (let i = 0, l = arr.length; i < l; i++) {
    if (prop) {
      lkup[arr[i][prop]] = true
    }
    else {
      lkup[arr[i]] = true
    }
  }
  return lkup
}

function getItemsByProp(arr, prop, values) {
  let items = []
  let found = 0
  let valuesLookup = makeLookup(values)
  for (let i = 0, la = arr.length, lv = values.length;
       i < la && found < lv;
       i++) {
    if (valuesLookup[arr[i][prop]]) {
      items.push(arr[i])
      found++
    }
  }
  return items
}

const DEFAULT_CLASS_NAMES = {
  button: 'FilteredMultiSelection__button',
  buttonActive: 'FilteredMultiSelection__button--active',
  filter: 'FilteredMultiSelection__filter',
  select: 'FilteredMultiSelection__select'
}

class FilteredMultiSelection extends React.Component {
  static propTypes = {
    onChange: t.func.isRequired,
    options: t.array.isRequired,

    buttonText: t.string,
    className: t.string,
    classNames: t.object,
    height: t.string,
    defaultFilter: t.string,
    disabled: t.bool,
    placeholder: t.string,
    selectedOptions: t.array,
    showFilter: t.bool,
    multiSelect: t.bool,
    size: t.number,
    textProp: t.string,
    valueProp: t.string,
    requiredProp: t.string,
    selectFiresOnChange: t.bool
  }

  static defaultProps = {
    buttonText: 'Select',
    className: 'FilteredMultiSelection',
    classNames: {},
    height: '300px',
    defaultFilter: '',
    disabled: false,
    placeholder: 'type to filter',
    selectedOptions: [],
    showFilter: true,
    multiSelect: true,
    size: 6,
    textProp: 'text',
    valueProp: 'value',
    requiredProp: 'required',
    selectFiresOnChange: false
  }

  constructor(props) {
    super(props)

    let {defaultFilter, selectedOptions} = props
    this.state = {
      // Filter text
      filter: defaultFilter,
      // Options which haven't been selected and match the filter text
      filteredOptions: this._filterOptions(defaultFilter, selectedOptions),
      // Values of <options> currently selected in the <select>
      selectedValues: []
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Update visible options in response to options or selectedOptions
    // changing. Also update selected values after the re-render completes, as
    // one of the previously selected options may have been removed.
    if (nextProps.options !== this.props.options ||
        nextProps.selectedOptions !== this.props.selectedOptions ||
        nextProps.options.length !== this.props.options.length ||
        nextProps.selectedOptions.length !== this.props.selectedOptions.length) {
      this.setState({
        filteredOptions: this._filterOptions(this.state.filter,
                                             nextProps.selectedOptions,
                                             nextProps.options)
      }, this._updateSelectedValues)
    }
  }

  _getClassName(name, ...modifiers) {
    let classNames = [this.props.classNames[name] || DEFAULT_CLASS_NAMES[name]]
    for (let i = 0, l = modifiers.length; i < l; i++) {
      if (modifiers[i]) {
        classNames.push(this.props.classNames[modifiers[i]] || DEFAULT_CLASS_NAMES[modifiers[i]])
      }
    }
    return classNames.join(' ')
  }

  _filterOptions(filter, selectedOptions, options) {
    if (typeof filter === 'undefined') {
      filter = this.state.filter
    }
    if (typeof selectedOptions === 'undefined') {
      selectedOptions = this.props.selectedOptions
    }
    if (typeof options === 'undefined') {
      options = this.props.options
    }
    filter = filter.toUpperCase()

    let {textProp, valueProp} = this.props
    let selectedValueLookup = makeLookup(selectedOptions, valueProp)
    let filteredOptions = []

    for (let i = 0, l = options.length; i < l; i++) {
      if (!selectedValueLookup[options[i][valueProp]] &&
          (!filter || options[i][textProp].toUpperCase().indexOf(filter) !== -1)) {
        filteredOptions.push(options[i])
      }
    }

    return filteredOptions
  }

  _selectRef = (select) => {
    this._select = select
  }

  _onFilterChange = (e) => {
    let filter = e.target.value
    this.setState({
      filter,
      filteredOptions: this._filterOptions(filter)
    }, this._updateSelectedValues)
  }

  _onFilterKeyPress = (e) => {
      if (e.key === 'Enter') {       
      e.preventDefault()
      if (this.state.filteredOptions.length === 1) {
        let selectedOption = this.state.filteredOptions[0]
        let selectedOptions = this.props.selectedOptions.concat([selectedOption])
        this.setState({filter: '', selectedValues: []}, () => {
          this.props.onChange(selectedOptions)
        })
      }
    }
  }

  _updateSelectedValues = (e) => {
    // let el = e ? e.target : this._select
    // let selectedValues = []
    // for (let i = 0, l = el.options.length; i < l; i++) {
    //   if (el.options[i].selected) {
    //     selectedValues.push(el.options[i].value)
    //   }
    // }
    // // Always update if we were handling an event, otherwise only update if
    // // selectedValues has actually changed.
    // if (e || String(this.state.selectedValues) !== String(selectedValues)) {
    //   this.setState({selectedValues})
    // }
  }

  /**
   * Adds backing objects for the currently selected options to the selection
   * and calls back with the new list.
   */
  _addSelectedToSelection = (e) => {
    const selectedItems = getItemsByProp(this.state.filteredOptions,
                                                       this.props.valueProp,
      this.state.selectedValues);
    
    // Set the "active" to false so the other side doesn't think that it is selected
    // this fixed the bug that caused all previously selected items to be removed
    // after adding them to one side
    selectedItems.forEach((item) => { item.active = false; });
      let selectedOptions = this.props.selectedOptions.concat(selectedItems);

    this.setState({selectedValues: []}, () => {
      this.props.onChange(selectedOptions)
    })
  }

  selectProperty = (value, isSelected) => {
    console.log(value + ": " + isSelected);
    let selectedValues = [];

    const filteredOptions = this.state.filteredOptions;
    for (let i = 0, l = filteredOptions.length; i < l; i++) {
      // If this is only single select, clear all the selections first
      if (!this.props.multiSelect) {
        filteredOptions[i].active = false;
      }
      if (filteredOptions[i][this.props.valueProp] === value) {
          filteredOptions[i].active = isSelected;
          selectedValues.push(value);
      } else if (filteredOptions[i].active) {
          selectedValues.push(filteredOptions[i][this.props.valueProp]);
      }
    }
    selectedValues.sort(sortByOrder);
    //if (String(this.state.filteredOptions) !== String(filteredOptions)) {
      this.setState({filteredOptions});
    //}
    // Always update if we were handling an event, otherwise only update if
    // selectedValues has actually changed.
    //if (String(this.state.selectedValues) !== String(selectedValues)) {
      this.setState({selectedValues}, () => {
        if (this.props.selectFiresOnChange) {
          this._addSelectedToSelection();
        }
      });
    //}
  };
  
  render() {
    let {filter, filteredOptions, selectedValues} = this.state
    let {className, disabled, placeholder, showFilter, textProp, valueProp, requiredProp, orphanedProp} = this.props
    let hasSelectedOptions = selectedValues.length > 0
    return <div className={className}>
      {showFilter && <input
        type="text"
        className={this._getClassName('filter')}
        placeholder={placeholder}
        value={filter}
        onChange={this._onFilterChange}
        onKeyPress={this._onFilterKeyPress}
        disabled={disabled}
      />}
      <div style={{height:this.props.height, overflowY:'auto', border:'solid 1px #ccc', padding: '6px'}}>
      {filteredOptions.map((option) => {
          return <SelectionRow key={option[valueProp]}
                               onSelect={this.selectProperty}
                               value={option[valueProp]}
                               text={option[textProp]}
                               required={option[requiredProp]}
                               entity={option}
                               orphaned={option[orphanedProp] ? option[orphanedProp] : false} />
        })}
      </div>
      {/* <select multiple
        ref={this._selectRef}
        className={this._getClassName('select')}
        size={size}
        value={selectedValues}
        onChange={this._updateSelectedValues}
        onDoubleClick={this._addSelectedToSelection}
        disabled={disabled}>
        {filteredOptions.map((option) => {
          return <option key={option[valueProp]} value={option[valueProp]}>{option[textProp]}</option>
        })}
      </select> */}
      { this.props.buttonText !== "" &&
      <button type="button"
        className={this._getClassName('button', hasSelectedOptions && 'buttonActive')}
        disabled={!hasSelectedOptions}
        onClick={this._addSelectedToSelection}>
        {this.props.buttonText}
      </button>
      }
    </div>
  }
}

class SelectionRow extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          active: false
      };
  }

  componentWillReceiveProps(nextProps) {
    // Update visible options in response to options or selectedOptions
    // changing. Also update selected values after the re-render completes, as
    // one of the previously selected options may have been removed.
    if (nextProps.entity !== this.props.entity) {
      // if the property "active" exists on the entity it means that it
      // was updated from the calling component. The active setting will override
      // the local state which allows the select single only to work - this unselects the element
      if (typeof(this.props.entity.active) !== undefined) {
        this.setState({active: this.props.entity.active});
      }
    }
  }
  toggleClass = () => {
      if (!this.props.required) {
      const currentState = this.state.active;
      this.setState({ active: !currentState },
        () => {
          if (this.props.onSelect) {
              this.props.onSelect(this.props.value,this.state.active);
          }
        });
      }
    };
  performSelection = () => {
    console.log("selected");
  }
  getToolTip = () => (this.props.required) ? "Required" : "";

  getClassName = () => {
    let className = "multi-select-item";
    if (this.state.active) {
        className += " selected";
    }
    if (this.props.required) {
      className += " required";
      if (this.props.entity.allowRequiredSelection){
        className += " allowSelection";
      }
    }
    if (this.props.entity && this.props.entity.isSeparator) {
      className += " separator";
        //className += "separator";
      // if (!this.props.allowSeparatorSelection) {
      //   className += " required";
      // }
    }
    return className;
  };

  render() {
      return (
        <div 
            className={this.getClassName()}
            onClick={this.toggleClass}
            title={this.getToolTip()}>
            {/* <button title="Select Now" onClick={this.performSelection}>+</button> */}
            <span>{this.props.text}</span>
        </div>
      )
  }
}
export default FilteredMultiSelection